import React from "react";

export const Hero = ({ heroRef }) => (
  <section className="bp-hero" ref={heroRef} aria-labelledby="bp-hero-title" data-testid="hero-section">
    <div className="bp-wrap bp-hero-inner">
      <span className="bp-hero-rule" aria-hidden="true" />
      <h1 id="bp-hero-title" className="bp-hero-title" data-testid="hero-title">
        There is a technology that will transform your business and your life over the coming years.
      </h1>
      <p className="bp-hero-line2" data-testid="hero-line-2">I speak, of course, about live theatre.</p>
      <p className="bp-hero-line3" data-testid="hero-line-3">
        <span className="bp-hero-brand">The Business Playwright</span> brings theatre into businesses, and puts business stories on the stage.
      </p>
    </div>
  </section>
);
